export default "__VITE_ASSET__C8QH5kYw__"